import { render } from "./Announcement.vue?vue&type=template&id=69f8d186&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=69f8d186&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f8d186"]])

export default __exports__